export default {
  "HitPaw Online Audio Joiner": "HitPawオンライン音声データ結合機",
  "Merge Audio": "音声データを結合する",
  "Merge multiple audio tracks into one.": "複数の音声トラックを１つに結合します。",
  "Merge New": "新しいものを結合する",
  "Merge failed": "結合失敗",
  "Fade in": "フェードイン",
  "Fade out": "フェードアウト",
  "Add tracks": "トラックを追加する",
  "Format": "形式",
};
